import React from 'react'
import PropTypes from 'prop-types'

function UserReviewButtons({ reviews, onClick }) {
  return (
    <div className="btn-group">
      {reviews.map((review) => (
        <button
          key={`reviews-toggle-button-${review.type}`}
          type="button"
          className={`btn ${review.isVisible ? 'btn-primary' : 'btn-outline-default btn-white btn-dark'}`}
          onClick={onClick}
        >
          {review.title}
          <span>{` (${review.total})`}</span>
        </button>
      ))}
    </div>
  )
}

UserReviewButtons.propTypes = {
  reviews: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default UserReviewButtons
